export enum BackgroundLayerType {
  BASE_MAP = 'BASE_MAP',
  LIGHT_MAP = 'LIGHT_MAP',
  DARK_MAP = 'DARK_MAP',
  SATELLITE_MAP = 'SATELLITE_MAP',
}
